import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import React, { useEffect, useState } from 'react'
import styles from './unexecutedPrescription.module.css'
import moment from 'moment'
import {
  DateTimeFormat,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimples,
} from '../../../../models/datetime'
import {
  CaretDownFilled,
  CloseOutlined,
  PlusOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import FileUpload from '../../../../compnents/file/FileUpload'
import { unwrapResult } from '@reduxjs/toolkit'
import { getUrl } from '../../../treatment/diagnosis/diagnosisSlice'
import { StationCategory } from '../../../../models/user'
import { getUsersInDepartmentAsync } from '../../../completion/completionSlice'
import { selectTenantName, selectUserId } from '../../../../app/applicationSlice'
import { defaultXianBingListAsync } from '../../../treatment/tcmCases/tcmCasesSlice'
import { SettingTreatmentParts } from '../../../examinetreat/settingTreatmentParts'
import { EditableList } from '../../../../compnents/list/EditableList'
import { ExcuteRecordColumns } from './column'
import { getExecuteSubmit, getExecutionDetail } from './unexecutedPrescriptionSlice'

const { Option } = Select

export const BatchExcuteModal = (props: {
  id?: any
  edit?: boolean
  treatmentServiceName?: any
  recipeId?: any
  recipeItemId?: any
  singleState: boolean
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detailList, setDetailList] = useState<any>()

  const [assistantList, setAssistantList] = useState<any>()

  const UserId = useSelector(selectUserId)

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const firstLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }

  useEffect(() => {
    // 默认回填
    if (props.isModalVisible) {
      form.setFieldsValue({
        executeTime: moment(),
      })
    } else {
      form.resetFields()
      setDetailList([])
      setFileList([])
    }
  }, [props.isModalVisible])

  useEffect(() => {
    // 获取执行人
    if (props.isModalVisible) {
      dispatch(
        getUsersInDepartmentAsync({
          departmentId: '',
          stationCategory: StationCategory.DoctorOrPharmacist,
          multyStationCategory: '0,1',
        })
      )
        .then(unwrapResult)
        .then((res) => {
          setAssistantList(res)
          const operatorId = res?.find((v: any) => v?.id == UserId.toString())?.id ? [UserId.toString()] : []
          form.setFieldsValue({
            operatorId: operatorId,
          })
        })
    }
  }, [props.isModalVisible])

  useEffect(() => {
    // 获取展示列表格
    const params = props?.singleState ? {
      recipeId: props?.recipeId,
      recipeItemId: props?.recipeItemId
    } : {
      recipeId: props?.recipeId,
    }
    if (props.isModalVisible) {
      dispatch(
        getExecutionDetail({
          ...params,
        })
      )
        .then(unwrapResult)
        .then((res: any) => {
          // 初始化每个项目的执行次数为1
          const initializedList = res?.map((item: any) => ({
            ...item,
            executeNum: item?.remainNum >= 1 ? 1 : item?.remainNum,
            workstationId: item?.id,
          }))
          setDetailList(initializedList)
        })
    }
  }, [props.isModalVisible])


  return (
    <Modal
      width={1000}
      title={props?.singleState ? '单个执行' : '批量执行'}
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <div style={{ height: '600px', overflowY: 'auto', marginBottom: '16px', paddingRight: '16px' }}>
        <Form
          className={styles.form}
          name='basic'
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            const invalidItems = detailList?.filter((v: any) => {
              const executeNum = Number(v?.executeNum)
              const remainNum = Number(v?.remainNum)
              // 正则
              const intReg = new RegExp(/^[0-9]\d*$/)
              return !intReg.test(String(executeNum)) || executeNum > remainNum
            })
            if (invalidItems?.length) {
              notification.warning({
                message: '提示',
                description: invalidItems.map((item: any) =>
                  `【${item.recipeName}】执行次数须为正整数，且不超过剩余次数`
                ).join('；'),
              })
              return
            }

            setConfirmLoading(true)
            const data = assistantList.filter((item: any) =>
              values.operatorId.includes(item.id)
            )
            const operatorName = data.map((item: any) => item.name)
            const momentType = DateTimeFormatSimples
            const params =
              detailList?.map((v: any) => {
                return {
                  ...v,
                  ...values,
                  recipeId: props?.recipeId,
                  recipeItemId: props?.recipeItemId,
                  executeNum: v?.executeNum ? v?.executeNum : '',
                  operatorName: operatorName?.length
                    ? operatorName?.join(',')
                    : '',
                  operatorId: values?.operatorId?.length
                    ? values?.operatorId?.join(',')
                    : '',
                  executeTime: values?.executeTime
                    ? moment(values?.executeTime).format(momentType)
                    : moment().format(momentType),
                  attachmentFile: fileList
                    ?.map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
                    ?.join(','),
                }
              })
            dispatch(getExecuteSubmit(
              params,
            ))
              .then(unwrapResult)
              .then((v) => {
                notification.success({
                  message: '操作成功',
                })
                props.onOk()
              })
              .catch((err) => {
                props.onCancel()
              })
              .finally(() => {
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                name='operatorId'
                label='执行人：'
                rules={[{ required: true, message: '请选择执行人' }]}
              >
                <Select
                  mode='multiple'
                  placeholder='执行人'
                  allowClear
                >
                  {assistantList?.map((v: any) => (
                    <Option key={v.id?.toString()} value={v.id?.toString()}>
                      {v.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                required
                name='executeTime'
                label='执行时间'
                rules={[{ required: true, message: '请选择本次执行时间' }]}
              >
                <DatePicker
                  showTime
                  format='YYYY/MM/DD HH:mm'
                  style={{
                    width: '100%',
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                {...firstLayout}
                name='remark'
                label='备注：'
              >
                <Input.TextArea showCount maxLength={100} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item name='attachmentFile' label='附件'
                {...firstLayout}>
                <FileUpload
                  count={(fileList && fileList.length) || 0}
                  files={fileList}
                  onUpload={(v, i) => {
                    setFileList([
                      ...fileList,
                      {
                        uid: v.uid,
                        size: v.size,
                        name: v.name,
                        type: v.type,
                        originFileObj: {} as RcFile,
                        url: i,
                      },
                    ])
                  }}
                >
                  <Button icon={<PlusOutlined />}>上传附件</Button>
                </FileUpload>
                {fileList &&
                  fileList.map((item) => (
                    <Row
                      gutter={24}
                      key={item.uid}
                      style={{
                        padding: '10px',
                        width: '300px',
                      }}
                    >
                      <Col flex={1}>
                        <span
                          style={{
                            display: 'inline-block',
                            maxWidth: '60px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            verticalAlign: 'middle',
                          }}
                        >
                          {item.name.split('.')[0]}
                        </span>
                        <span
                          style={{
                            verticalAlign: 'middle',
                          }}
                        >
                          .{item.name.split('.')[1]}
                        </span>
                      </Col>
                      <Col span={6}>
                        <a
                          onClick={() => {
                            dispatch(getUrl({ fileName: item.url }))
                              .then(unwrapResult)
                              .then((v: any) => {
                                const proxy =
                                  window.location.origin.indexOf(
                                    'his.develop.hydhis.com'
                                  ) >= 0
                                    ? '/proxyToOssDevPrivate'
                                    : window.location.origin.indexOf(
                                      'his.test.hydhis.com'
                                    ) >= 0
                                      ? '/proxyToOssTestPrivate'
                                      : window.location.origin.indexOf('hydhis.cn') >= 0
                                        ? '/proxyToOssProdPrivate'
                                        : '/proxyToOssProdPrivate'
                                const url =
                                  (window.location.origin?.includes('localhost')
                                    ? 'http://hydhis.cn'
                                    : window.location.origin) +
                                  proxy +
                                  v
                                window.open(url, '_blank')
                              })
                          }}
                        >
                          查看
                        </a>
                      </Col>
                      <Col span={6}>
                        <CloseOutlined
                          onClick={() => {
                            //  e.stopPropagation();
                            setFileList(() =>
                              fileList.filter((ite) => ite.uid !== item.uid)
                            )
                          }}
                        />
                      </Col>
                    </Row>
                  ))}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <EditableList
                bordered
                pagination={false}
                page={{
                  items: detailList || [],
                  current: 1,
                  size: 10,
                  total: 0,
                }}
                columns={ExcuteRecordColumns((t, v, e) => {
                  if (t === 'changeExecuteNum') {
                    setDetailList(detailList?.map((item: any) => ({
                      ...item,
                      executeNum: v?.id == item.id ? e : item.executeNum,
                    })))
                  } else if (t === 'changeTreatmentParts') {
                    setDetailList(detailList?.map((item: any) => ({
                      ...item,
                      treatmentParts: v?.id == item.id ? (e ? e?.join(',') : '') : item.treatmentParts,
                    })))
                  }
                })} />
            </Col>
          </Row>
        </Form>
      </div>
      <Row gutter={20}>
        <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            style={{ marginRight: '10px' }}
            onClick={() => {
              props?.onCancel && props?.onCancel()
            }}>
            取消
          </Button>
          <Button
            loading={confirmLoading}
            type='primary'
            onClick={() => {
              form.submit()
            }}>
            {props?.edit ? '编辑' : '确认执行'}
          </Button>
        </Col>
      </Row>
    </Modal >
  )
}